import { useEffect, useState } from 'react';

const MIN_WIDTH_DESKTOP = 769;
const MEDIA_QUERY = `(min-width: ${MIN_WIDTH_DESKTOP}px)`;

export const useMedia = () => {
  const [isDesktop, setIsDesktop] = useState(
    window.matchMedia(MEDIA_QUERY).matches,
  );

  useEffect(() => {
    const media = window.matchMedia(MEDIA_QUERY);
    const listener = () => setIsDesktop(media.matches);

    // Safari 14 below backward compatibility. https://developer.mozilla.org/en-US/docs/Web/API/MediaQueryList#:~:text=MediaQueryList%20inherits-,EventTarget,-39
    if (media.addEventListener) {
      media.addEventListener('change', listener);
    } else {
      media.addListener(listener);
    }

    return () => {
      if (media.removeEventListener) {
        media.removeEventListener('change', listener);
      } else {
        media.removeListener(listener);
      }
    };
  }, []);

  return { isDesktop };
};
